import { axiosPrivateInstance } from 'libs/axios';
import { GET_ALL_PRODUCT_GROUP_NAME } from 'utils/serviceUrls';

const getAllProductGroupNameService = async () => {
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(GET_ALL_PRODUCT_GROUP_NAME)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default getAllProductGroupNameService;
